import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem',
  },
  spinner: {
    color: neutral['100'],
  },
  title: {
    fontWeight: 500,
    fontSize: '1.25rem',
    lineHeight: '1.5rem',
  },
  description: {
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1rem',
  },
});
